import { render, staticRenderFns } from "./avis-medical.html?vue&type=template&id=fe284382&external"
import script from "./avis-medical.js?vue&type=script&lang=js&external"
export * from "./avis-medical.js?vue&type=script&lang=js&external"
import style0 from "./avis-medical.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./avis-medical-ui.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports